export const contacts = [
  {
    name: "Phone",
    icon: <i className="pi pi-phone" style={{ fontSize: "1.5rem" }}></i>,
    value: ["+233 302443 824", "+233 546 044 523"],
  },
  {
    name: "Email",
    icon: <i className="pi pi-envelope" style={{ fontSize: "1.5rem" }}></i>,
    value: ["info@myrosswood.com", "sales@myrosswood.com"],
  },
  {
    name: "Address",
    icon: <i className="pi pi-home" style={{ fontSize: "1.5rem" }}></i>,
    value: ["East Legon", "Accra Ghana"],
  },
];

export const faqs = [
  {
    header: "This is a question number one",
    panel:
      "Lorem ipsum dolor sit amet consectetur. Etiam imperdiet in blandit penatibus lacus tellus ridiculus quis. Proin nullam faucibus odio mi donec integer dictum. Sed non pharetra vel dui etiam tellus. Suscipit amet odio nunc feugiat. Sodales nibh mollis cras et felis porttitor.",
  },
  {
    header: "This is a question number two and this may be that long",
    panel:
      "Lorem ipsum dolor sit amet consectetur. Etiam imperdiet in blandit penatibus lacus tellus ridiculus quis. Proin nullam faucibus odio mi donec integer dictum. Sed non pharetra vel dui etiam tellus. Suscipit amet odio nunc feugiat. Sodales nibh mollis cras et felis porttitor.",
  },
  {
    header: "This is a question number one and another one here too",
    panel:
      "Lorem ipsum dolor sit amet consectetur. Etiam imperdiet in blandit penatibus lacus tellus ridiculus quis. Proin nullam faucibus odio mi donec integer dictum. Sed non pharetra vel dui etiam tellus. Suscipit amet odio nunc feugiat. Sodales nibh mollis cras et felis porttitor.",
  },
  {
    header: "This is a question number one this can be three",
    panel:
      "Lorem ipsum dolor sit amet consectetur. Etiam imperdiet in blandit penatibus lacus tellus ridiculus quis. Proin nullam faucibus odio mi donec integer dictum. Sed non pharetra vel dui etiam tellus. Suscipit amet odio nunc feugiat. Sodales nibh mollis cras et felis porttitor.",
  },
  {
    header: "This is a question number one this can be more too who will know",
    panel:
      "Lorem ipsum dolor sit amet consectetur. Etiam imperdiet in blandit penatibus lacus tellus ridiculus quis. Proin nullam faucibus odio mi donec integer dictum. Sed non pharetra vel dui etiam tellus. Suscipit amet odio nunc feugiat. Sodales nibh mollis cras et felis porttitor.",
  },
];

export const customerTraceHistory = [
  {
    cte: "Buying from farmer",
    kdes: [
      {
        label: "Name of Farmer",
        value: "John Doe",
      },
      {
        label: "Location of farm",
        value: "Bogoso",
      },
      {
        label: "Date of harvest",
        value: "2021-09-01",
      },
      {
        label: "Quantity of harvest",
        value: "1000",
      },
      {
        label: "Unit of harvest",
        value: "kg",
      },
      {
        label: "Name of crop",
        value: "Cocoa",
      },
      {
        label: "Variety of crop",
        value: "Cocoa",
      },
      {
        label: "Date of harvest",
        value: "2021-09-01",
      },
    ],
  },
  {
    cte: "Transporting to Warehouse",
    kdes: [
      {
        label: "Location of Warehouse",
        value: "Accra",
      },
      {
        label: "Arrival Date",
        value: "2021-09-01",
      },
      {
        label: "Condition of harvest",
        value: "Good",
      },
    ],
  },
  {
    cte: "Processing",
    kdes: [],
  },
  {
    cte: "Packaging",
    kdes: [],
  },
];

export const emptyStates = [
  {
    title: "RECENT CRITICAL TRACKING EVENT",
    icon: "pi pi-bolt",
    route: "",
    desc: "Currently, there are no CTEs added. CTEs will be displayed here once they are added.",
  },
  {
    title: "RECENT KEY DATA ELEMENT",
    icon: "pi pi-th-large",
    route: "",
    desc: "Currently, there are no KDEs added. KDEs will be displayed here once they are added.",
  },
  {
    title: "RECENT PRODUCTS",
    icon: "pi pi-box",
    route: "",
    desc: "Currently, there are no products added. Products will be displayed here once they are added.",
  },
  {
    title: "RECENT USERS",
    icon: "pi pi-users",
    route: "",
    desc: "Currently, there are no users added. Users will be displayed here once they are added.",
  },
];

export const statistics = [
  {
    icon: "pi pi-users",
    title: "USERS",
    color: "#008F4B",
    bgColor: "#E1F5E1",
    value: 10,
    activeValue: 8,
    inActiveValue: 2,
  },
  {
    icon: "pi pi-sitemap",
    title: "ROLES",
    color: "#FBB33A",
    bgColor: "#FAF5E1",

    value: 5,
    activeValue: 4,
    inActiveValue: 1,
  },
  {
    icon: "pi pi-sitemap",
    title: "PRODUCTS",
    color: "#0063EA",
    bgColor: "#E5EEFF",
    value: 5,
    activeValue: 5,
    inActiveValue: 0,
  },
  {
    icon: "pi pi-history",
    title: "TRACEABILITY FLOWS",
    color: "#E31333",
    bgColor: "#FDEAEA",
    value: 5,
    activeValue: 30,
    inActiveValue: 10,
  },
  {
    icon: "pi pi-bolt",
    title: "CRITICAL TRACKING EVENTS",
    color: "#008F4B",
    bgColor: "#E1F5E1",
    value: 34,
    activeValue: 34,
    inActiveValue: 1,
  },
  {
    icon: "pi pi-th-large",
    title: "KEY DATA ELEMENTS",
    color: "#FBB33A",
    bgColor: "#FAF5E1",
    value: 63,
    activeValue: 60,
    inActiveValue: 3,
  },
];

   
 export const navMenus = [
    {
          label: "Home",
         url: "/home"
    },
    {
        label: "About Us",
         url: "/about-us"
    },
    {
        label: "Our Products",
         url: "/our-products"
    },
    {
        label: "Gallery",
         url: "/gallery"
    },
    {
        label: "Stories",
        url: "/stories"
    },
    {
        label: "Track",
        url: "/tracking"
    },
    {
        label: "Contact Us",
         url: "/contact-us"
    },
    ];
